import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../core/services/config/config.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { PatientDocument, PatientDocumentSummary } from '../../models/patient-document';

@Injectable({
  providedIn: 'root',
})
export class PatientDocumentsService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  endpoint = `${this.config.patientApiUrl}/v1/PatientPortal/PatientDocuments`;

  getPatientDocuments(patientId: number): Observable<PatientDocumentSummary[]> {
    const url = `${this.endpoint}/PortalDocuments?patientId=${patientId}`;
    // List read: ReportsComponent renders app-error-state with a retry.
    return this.utilityService.getRequest<PatientDocumentSummary[]>(url, { skipGlobalError: true });
  }

  getPatientDocument(patientDocumentId: number, patientId: number): Observable<PatientDocument> {
    const url = `${this.endpoint}/PortalDocument?patientDocumentId=${patientDocumentId}&patientId=${patientId}`;
    // Preview read — see PatientNotesService.getPatientNote: opting out is what makes the preview's
    // local error pane reachable instead of being pre-empted by the global error navigation.
    return this.utilityService.getRequest<PatientDocument>(url, { skipGlobalError: true });
  }

  postPrintEvent(patientId: number, patientDocumentId: number): Observable<void> {
    const url = `${this.endpoint}/PortalDocument/${patientDocumentId}/PrintEvent?patientId=${patientId}`;
    return this.utilityService.postRequest<void>(url, null, { skipGlobalError: true });
  }
}
